<script>
import SkokkaCarousel from "../../carousel/carousel.vue";
import SkokkaCarouselSlide from "../../carousel/carousel-slide.vue";
import SkokkaGalleryModal from "./gallery-modal.vue";
import { createDOMElement, waitForCondition } from '../../../services/utils';

export const slideCloneClass = "slide-clone";
const baguetteBoxStylesLink = "https://cdnjs.cloudflare.com/ajax/libs/baguettebox.js/1.11.0/baguetteBox.min.css";
const baguetteBoxScriptLink = "https://cdnjs.cloudflare.com/ajax/libs/baguettebox.js/1.11.0/baguetteBox.min.js";

export default {
    name: "SkokkaGallery",
    components: {
        SkokkaCarousel,
        SkokkaCarouselSlide,
        SkokkaGalleryModal
    },
    props: {
        items: {
            type: [Array, String],
            required: true
        },
        infiniteScroll: {
            type: Boolean,
            default: false,
        },
        autoScroll: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            images: Array.isArray(this.items) ? this.items : [this.items],
            mobileBreakpoint: 576
        };
    },
    computed: {
        isDesktop() {
            return document.body.clientWidth > this.mobileBreakpoint;
        }
    },
    methods: {
        baguetteBoxIsDefined() {
            return "baguetteBox" in window && typeof window.baguetteBox.run === 'function';
        },
        initBaguetteBox: async function () {
                try {
                    if(this.baguetteBoxIsDefined()) {
                        if (this.isDesktop) {
                            window.baguetteBox.run(".carousel-track.masonry", {
                                captions: false,
                                ignoreClass: slideCloneClass,
                            });
                        }
                    } else {         
                        createDOMElement('link', {
                            rel: "stylesheet",
                            href: baguetteBoxStylesLink,
                        }, document.head);

                        createDOMElement('script', {
                            src: baguetteBoxScriptLink,
                        }, document.body);

                        await waitForCondition(this.baguetteBoxIsDefined);
                        
                        this.initBaguetteBox();
                    }
                } catch (error) {
                    console.error("Failed to run baguetteBox", error);
                }
            }
    },
    mounted() {
        window.addEventListener('load', this.initBaguetteBox);
    },
    beforeDestroy(){
        window.removeEventListener('load', this.initBaguetteBox);

        if(this.baguetteBoxIsDefined()) {
            window.baguetteBox.destroy();
        }
    },
};
</script>

<template>
    <div class="skokka-gallery">
        <skokka-gallery-modal :items="images" v-if="images.length > 1" />
        <skokka-carousel :infinite="infiniteScroll" :auto="autoScroll" track-class-name="masonry">
            <skokka-carousel-slide v-for="(src, i) in images" :key="`${i}-slide`" class="gallery-item">
                <a :href="src" v-if="isDesktop">
                    <img :src="src" />
                </a>
                <img :src="src" v-else />
            </skokka-carousel-slide>
        </skokka-carousel>
    </div>
</template>